/**
 * Checkout.com Flow (web components) loader.
 *
 * The script MUST be loaded directly from checkout-web-components.checkout.com
 * (never bundled/self-hosted) to stay PCI compliant. It exposes a global async
 * `CheckoutWebComponents` factory.
 */
const FLOW_SCRIPT_SRC = 'https://checkout-web-components.checkout.com/index.js';

export const loadCheckoutWebComponents = (): Promise<void> =>
  new Promise((resolve, reject) => {
    if ((window as any).CheckoutWebComponents) {
      resolve();
      return;
    }
    const existing = document.querySelector(
      `script[src='${FLOW_SCRIPT_SRC}']`
    ) as HTMLScriptElement | null;
    if (existing) {
      existing.addEventListener('load', () => resolve());
      existing.addEventListener('error', () =>
        reject(new Error('Failed to load Checkout Flow'))
      );
      return;
    }
    const script = document.createElement('script');
    script.src = FLOW_SCRIPT_SRC;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load Checkout Flow'));
    document.body.appendChild(script);
  });

/**
 * Checkout sandbox public keys are prefixed `pk_sbox_`; production keys `pk_`.
 * Infer the Flow environment from the key so we don't need an extra env var.
 */
export const checkoutEnvironment = (
  publicKey: string
): 'sandbox' | 'production' =>
  publicKey.startsWith('pk_sbox') ? 'sandbox' : 'production';
